import {boundMethod} from "autobind-decorator";
import React from "react";
import {injectIntl, IntlShape} from "react-intl";

import {CHART_EXPORT_HEIGHT, EDataColorSchemes} from "./models";

import InlineRadios from "@toolbox/button-like/InlineRadios";
import T, {intl2Str, parseNumber} from "@translate/T";
import {getCentColorImage, getSchemeImage} from "./images";

interface IFingerprintSchemeProps {
    intl: IntlShape;
    value: EDataColorSchemes;
    onChange(value: EDataColorSchemes): void;
}

class FingerprintScheme extends React.PureComponent<IFingerprintSchemeProps> {
    public render() {
        const {onChange, value, intl} = this.props;

        return (
            <div className="form-row mb-2">
                <div className="col-sm-2">
                    <label>
                        <T>Fingerprint scheme</T>
                    </label>
                </div>

                <div className="col-sm-4">
                    <InlineRadios<EDataColorSchemes>
                        breakEachElement={true}
                        idSuffix="fingerprint-scheme"
                        selected={value}
                        onSelected={onChange}
                        values={this.getContent([
                            <T key={EDataColorSchemes.RdGn}>Red green</T>,
                            <T key={EDataColorSchemes.RdYlGn}>
                                Red yellow green
                            </T>,
                            <T key={EDataColorSchemes.Viridis}>Viridis</T>,
                            <T key={EDataColorSchemes.Inferno}>Inferno</T>,
                            <T key={EDataColorSchemes.Turbo}>Turbo</T>,
                            <T key={EDataColorSchemes.ColorBlind}>
                                Color blind
                            </T>,
                        ])}
                    />
                </div>

                <div className="col-sm-4 align-self-center">
                    <img
                        alt={intl2Str(intl, "Fingerprint scheme")}
                        src={getCentColorImage(value)}
                        height={CHART_EXPORT_HEIGHT}
                    />
                </div>
            </div>
        );
    }

    @boundMethod
    private getContent(schemes: JSX.Element[]) {
        const {intl} = this.props;

        return schemes.map((scheme) => (
            <React.Fragment key={scheme.key as string}>
                {scheme}
                <br />
                <img
                    alt={intl2Str(intl, "Fingerprint scheme")}
                    src={getSchemeImage(
                        parseNumber(scheme.key as string) as EDataColorSchemes,
                    )}
                    width="256"
                    height="10"
                />
            </React.Fragment>
        ));
    }
}

export default injectIntl(FingerprintScheme);
